import React from "react";
import { Route } from "react-router-dom";
import AuthRoute from "./authRoute";

const renderRoutesMap = (routes, extraProps = {}) =>
  routes.map((route, i) => {
    const Component = route.component;
    return (
      <Route
        key={i}
        path={route.path}
        element={
          <AuthRoute
            auth={route.is_auth}
            component={Component}
            {...extraProps}
          />
        }
      />
    );
  });

export default renderRoutesMap;
